export const API_CODE = {
  REVERT_INTERNAL_WITHDRAW: 'revert_internal_withdraw',
  LOCK_USER: 'lock_user',
  UNLOCK_USER: 'unlock_user',
  TRACK_LOGIN: 'track_login',
  RESTART_SERVICE: 'service_restart',
}
